// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorPicker__container___1t-Io","pickerWrapper":"ColorPicker__pickerWrapper___1xA3D"};